import { useTranslation } from 'react-i18next'
import { Caption1, MenuItem, Select, Stack, TextField } from '@dhl-ui/components'

import type { Product } from '~/common/model/capabilities'
import type { ReturnHub } from '~/modules/returnhubsccc/model/ReturnHub'

type Props = {
  selectedProduct: Product
  returnHubs: ReturnHub[]
  onChangeProduct: (selectedProduct: Product) => void
}

export const ProductConfig = ({ selectedProduct, returnHubs, onChangeProduct }: Props) => {
  const { t } = useTranslation()

  const handleLocationIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChangeProduct({
      ...selectedProduct,
      returnHubId: selectedProduct.returnHubId || '',
      locationId: e.target.value,
      additionalCustomerInformation: selectedProduct.additionalCustomerInformation || '',
    })
  }

  const handleAdditionalCustomerInformationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChangeProduct({
      ...selectedProduct,
      returnHubId: selectedProduct.returnHubId || '',
      locationId: selectedProduct.locationId || '',
      additionalCustomerInformation: e.target.value,
    })
  }

  const handleReturnHubChange = (returnHubId: string) => {
    onChangeProduct({
      ...selectedProduct,
      returnHubId,
      locationId: selectedProduct.locationId || '',
      additionalCustomerInformation: selectedProduct.additionalCustomerInformation || '',
    })
  }

  const isReturnCCCorBoost = selectedProduct.value === 'RETURN-CCC' || selectedProduct.value === 'RETURN-CCC-BOOST'

  return (
    <Stack gap={1}>
      <Caption1>{t(`admin.returnHubPage.header`)}</Caption1>
      <TextField
        type="text"
        fullWidth
        label={t('admin.returnHubPage.locationId')}
        name="locationId"
        value={selectedProduct.locationId || ''}
        onChange={handleLocationIdChange}
        sx={{ mb: 0.5 }}
      />
      <Select
        name="returnHubId"
        value={selectedProduct.returnHubId || ''}
        label={t('admin.returnHubPage.returnHub')}
        fullWidth
      >
        {returnHubs.map(({ id, name }) => (
          <MenuItem key={id} value={id} onClick={() => handleReturnHubChange(id)}>
            {name}
          </MenuItem>
        ))}
      </Select>
      {isReturnCCCorBoost && (
        <TextField
          type="text"
          fullWidth
          label={t('admin.returnHubPage.additionalCustomerInformation')}
          name="additionalCustomerInformation"
          value={selectedProduct.additionalCustomerInformation || ''}
          onChange={handleAdditionalCustomerInformationChange}
          sx={{ mb: 0.5 }}
        />
      )}
    </Stack>
  )
}
